import { IProps as IImageProps } from 'marketing-site/src/library/elements/Image'
import { transformImage } from '../elements/ContentfulImage'
import {
  IEntry,
  IFeatureV2 as IContentfulFeature,
} from 'marketing-site/@types/generated/contentful'
import { IHyperlink, transformHyperlink } from './ContentfulHyperlink'
import { Document } from '@contentful/rich-text-types'

export interface IFeature {
  title: string
  icon: IImageProps
  description: Document
  image?: IImageProps
  link?: IHyperlink | undefined
}

export function isFeature(entry: IEntry): entry is IContentfulFeature {
  return entry.sys.contentType.sys.id === 'featureV2'
}

export function transformFeature({ fields }: IContentfulFeature): IFeature {
  return {
    ...fields,
    icon: fields.icon && transformImage(fields.icon),
    link: fields.link && transformHyperlink(fields.link),
    image: fields.image && transformImage(fields.image),
  }
}
